import { hasText } from '../utils/helpers'
import { API } from './api'
import {
  makeDeleteRequest,
  makeGetRequest,
  makePatchRequest,
  makePostRequest,
} from './fetchCalls'

async function listFormsWithPDF({
  page = 1,
  pageSize = 10,
  search = '',
}: {
  page?: number,
  pageSize?: number,
  search?: string,
}) {
  let url = `${API.FORM_BUILDER.FORM_WITH_PDF}?page=${page}&page_size=${pageSize}`
  if (search) {
    url += `&search=${search}`
  }
  return makeGetRequest(url)
}

async function createOrUpdateForm(data, formId = null) {
  const body = JSON.stringify(data)

  if (formId) {
    return makePatchRequest(API.FORM_BUILDER.FORM_ID_UPDATE(formId), { body })
  }

  return makePostRequest(API.FORM_BUILDER.FORM, { body })
}

async function deleteForm(id) {
  if (!hasText(id)) {
    return
  }
  return makeDeleteRequest(API.FORM_BUILDER.FORM_ID(id))
}

async function deletePages(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.PAGE_ID(id))
}

async function deleteSections(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.SECTION_ID(id))
}

async function deleteRows(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.ROW_ID(id))
}

async function deleteQuestions(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.QUESTION_ID(id))
}

async function deleteQuestionRows(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.QUESTION_ROW_ID(id))
}

async function deleteQuestionColumns(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.QUESTION_COLUMN_ID(id))
}

async function deleteQuestionChoices(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.QUESTION_CHOICE_ID(id))
}

async function deleteConditionalRules(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.CONDITIONAL_RULE_ID(id))
}

async function deleteConditionalRuleGroups(id) {
  if (!hasText(id)) return

  return makeDeleteRequest(API.FORM_BUILDER.CONDITIONAL_RULE_GROUP_ID(id))
}

async function deleteFormResources(id, data) {
  const body = JSON.stringify(data)
  return makePostRequest(
    API.FORM_BUILDER.BUILDER_FORM_FORM_DELETE_RESOURCE_ID(id),
    { body }
  )
}

const formBuilderAPI = {
  listFormsWithPDF,
  createOrUpdateForm,
  deleteForm,
  deletePages,
  deleteSections,
  deleteRows,
  deleteQuestions,
  deleteQuestionRows,
  deleteQuestionColumns,
  deleteQuestionChoices,
  deleteConditionalRules,
  deleteConditionalRuleGroups,
  deleteFormResources,
}

export default formBuilderAPI
